<template>
  <div>
    <p class="mb-2 text--primary">
      {{ $t('conversation_zerva_generic_button.description') }}
    </p>
    <p class="mb-2 grey--text">* {{ $t('conversation_zerva_generic_button.note') }}</p>
    <div>
      <label :for="`input-${_uid}`" class="d-block caption">ZERVA service ID</label>
      <v-text-field
        :id="`input-${_uid}`"
        v-validate="'required'"
        :value="value"
        name="value"
        outline
        single-line
        data-vv-as="ZERVA service ID"
        :error-messages="errors.collect('value')"
        @input="$emit('input', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/chatbot/ZervaServiceIdInput.vue